import {Outlet} from "react-router-dom";
import {useStore} from "../stores/Store";


export default function RequireNoAuth() {
    const {UserStore: {isLoggedIn}} = useStore();

    return <Outlet/>
}